import React from 'react'

const ForgotPassword = () => {
    return (
        <div>
            password
        </div>
    )
}

export default ForgotPassword
